import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Html5Qrcode } from 'html5-qrcode';

export default function BarcodeScannerModal({ onScan, onClose }) {
    const scannerRef = useRef(null);
    const [error, setError] = useState('');
    const readerId = useMemo(() => `barcode-reader-${Math.random().toString(36).slice(2)}`, []);

    useEffect(() => {
        let mounted = true;

        const startScanner = async () => {
            try {
                const cameras = await Html5Qrcode.getCameras();
                if (!mounted) return;

                if (!cameras || cameras.length === 0) {
                    setError('No camera was found on this device.');
                    return;
                }

                const backCamera = cameras.find((camera) => /back|rear|environment/i.test(camera.label || ''));
                const cameraId = (backCamera || cameras[0]).id;
                const scanner = new Html5Qrcode(readerId);
                scannerRef.current = scanner;

                await scanner.start(
                    cameraId,
                    { fps: 10, qrbox: { width: 260, height: 160 } },
                    async (decodedText) => {
                        if (!decodedText) return;
                        await scanner.stop().catch(() => {});
                        scanner.clear();
                        onScan(decodedText);
                    },
                    () => {}
                );
            } catch (err) {
                if (mounted) setError(err?.message || 'Camera scanner could not start.');
            }
        };

        startScanner();

        return () => {
            mounted = false;
            const scanner = scannerRef.current;
            if (scanner) {
                scanner.stop().catch(() => {}).finally(() => scanner.clear());
            }
        };
    }, [onScan, readerId]);

    return (
        <div className="scanner-modal-backdrop" role="dialog" aria-modal="true">
            <div className="scanner-modal">
                <div className="scanner-modal-head">
                    <div>
                        <h3>Scan Product Barcode</h3>
                        <p>Point the camera at the barcode on the product label.</p>
                    </div>
                    <button type="button" className="mini-icon-btn" onClick={onClose}>x</button>
                </div>
                <div id={readerId} className="scanner-reader" />
                {error ? <p className="scanner-error">{error}</p> : null}
                <button type="button" className="btn btn-outline" onClick={onClose}>Close Scanner</button>
            </div>
        </div>
    );
}
